import React from 'react';
import { Button } from 'bumbag';
import { Link as RouterLink } from 'react-router-dom';

type Props = {
  to: string;
};
export default class BackButton extends React.Component<Props> {
  render = () => {
    const { to } = this.props;
    return (
      // @ts-expect-error
      <Button use={RouterLink} to={to} palette="primary" variant="ghost">
        <i className="fa fa-angle-left margin-right-5" /> Back
      </Button>
    );
  };
}
